module.exports = __webpack_public_path__ + "static/media/patent-03.cee708ca.jpg";